/*No llamar al servicio de analytics en la directiva*/
angular.module('CarsSaraBo').directive('opaqueRateCard', ['$translate', 'DateService','$location', 'OpaqueRateGAConfig', function ($translate, dateService, $location, OpaqueRateGAConfig) {
    return {
        scope: {
            opaque: '=',
            remove: '&',
            isDeletable: '='
        },
        link: function (scope) {
            scope.isCollapsed = true;
            scope.detailsLabel = 'common.VIEW_DETAIL';
            var textOverflowVerified = false;
            var hasTextOverflow = false;
            var gaOpaqueRate = OpaqueRateGAConfig.reviewGa();

            scope.getCarsNames = function (opaqueRate) {
                var nameGenerator = function (car) {
                    return car.carModel.brand + ' ' + car.carModel.model + ' - ' + car.name;
                };
                return getNames(opaqueRate.cars, opaqueRate.allCarsSelected, 'opaqueRate.list.CARS.ALL', nameGenerator);
            };

            scope.getPointsOfSaleNames = function (opaqueRate) {
                var nameGenerator = function (pos) {
                    return pos.name;
                };
                return getNames(opaqueRate.pointsOfSale, opaqueRate.allPointsOfSaleSelected,'opaqueRate.list.POINTS_OF_SALE.ALL', nameGenerator);
            };

            function getNames(selectedItems, allSelectedFlag, allMessage, nameGenerator) {
                if (allSelectedFlag) {
                    return $translate.instant(allMessage);
                }
                var nameList = [];
                _.forEach(selectedItems, function (item) {
                    nameList.push(nameGenerator(item).toLowerCase());
                });
                return nameList.sort().join(', ');
            }

            scope.formatDate = function (dateString) {
                var pattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
                return dateString.replace(pattern, '$3/$2/$1');
            };

            scope.hasDetails = function (opaqueRate) {
                if (!textOverflowVerified) {
                    var hasCarsDetailOverflow = verifyTextOverflow(opaqueRate, '#carsDetails');
                    var hasPosDetailOverflow = verifyTextOverflow(opaqueRate, "#posDetails")
                    hasTextOverflow = hasCarsDetailOverflow || hasPosDetailOverflow;
                    if (hasTextOverflow) {
                        textOverflowVerified = true;
                    }
                }
                return hasTextOverflow;
            };

            function verifyTextOverflow(opaqueRate, elementName) {
                var nameElem = elementName + opaqueRate.oid;
                var details = angular.element(document.querySelector(nameElem))[0];
                return details.offsetWidth < details.scrollWidth;
            }

            scope.toggleDetails = function () {
                scope.isCollapsed = !scope.isCollapsed;
                if($location.$$path.indexOf('/opaquerate') > -1){
                    //scope.$parent.notifyGA(scope.isCollapsed?'Listado_moderación_ocultar_detalle':'Listado_moderación_ver_detalle', scope.opaqueRate);
                }
                setDetailsLabel();
            };

            function setDetailsLabel() {
                scope.isCollapsed ? scope.detailsLabel = 'common.VIEW_DETAIL' : scope.detailsLabel = 'common.HIDE_DETAIL';
                gaOpaqueRate.send(scope.isCollapsed?'Ocultar_detalle':'Ver_detalle');
            }
        },
        templateUrl: 'templates/opaque-rate/opaque-rate-card/opaque-rate-card.component.html'
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/opaque-rate/opaque-rate-card/opaque-rate-card.directive.js
// module id = 835
// module chunks = 3